import type { ComponentType, ReactNode } from 'react'
import type { PreviewZone } from '@/constants'

export interface PreviewFrameProps {
  uid: string
  sectionKey: string
  index: number
  zone: PreviewZone
  label: string
  deletable: boolean
  children: ReactNode
}

let frame: ComponentType<PreviewFrameProps> | null = null

export function setPreviewFrame(component: ComponentType<PreviewFrameProps> | null): void {
  frame = component
}

export function getPreviewFrame(): ComponentType<PreviewFrameProps> | null {
  return frame
}
